import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Pinterest = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 18 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 20 20"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <g id="Group_2">
          <path
            id="Vector"
            d="M10 0C4.47447 0 0 4.47784 0 10.0075C0 14.2449 2.62763 17.8663 6.35135 19.3238C6.26126 18.5274 6.18619 17.3253 6.38138 16.4538C6.56156 15.6724 7.55255 11.4801 7.55255 11.4801C7.55255 11.4801 7.25225 10.879 7.25225 9.99249C7.25225 8.59504 8.06306 7.55823 9.05405 7.55823C9.90991 7.55823 10.3153 8.20436 10.3153 8.9707C10.3153 9.8272 9.77477 11.1195 9.48949 12.3065C9.24925 13.2983 9.98498 14.1097 10.976 14.1097C12.7477 14.1097 14.1141 12.2314 14.1141 9.52667C14.1141 7.13749 12.3874 5.45455 9.93994 5.45455C7.1021 5.45455 5.42042 7.58828 5.42042 9.79714C5.42042 10.6536 5.75075 11.5853 6.17117 12.0811C6.24625 12.1863 6.26126 12.2615 6.24625 12.3666C6.17117 12.6822 6.00601 13.3584 5.97598 13.4936C5.93093 13.6739 5.82583 13.719 5.64565 13.6288C4.3994 13.0428 3.61862 11.2246 3.61862 9.75207C3.61862 6.59654 5.91592 3.69647 10.2252 3.69647C13.6937 3.69647 16.3814 6.17581 16.3814 9.46657C16.3814 12.9076 14.2042 15.6875 11.2012 15.6875C10.1952 15.6875 9.23423 15.1615 8.9039 14.5455C8.9039 14.5455 8.40841 16.4538 8.28829 16.9196C8.06306 17.7911 7.44745 18.873 7.04204 19.5492C7.97297 19.8347 8.96396 20 10 20C15.5255 20 20 15.5222 20 9.99249C20 4.47784 15.5255 0 10 0Z"
            fill="#BD081C"
          />
        </g>
      </g>
    </svg>
  )
})

export default Pinterest
